import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { TbBrandWhatsappFilled } from "react-icons/tb";
import { FaArrowRightLong } from "react-icons/fa6";



const ConatctChat = () => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const cards = [
    {
      iconSrc: "/Images/Border (1).png",
      title: "Phone",
      content: ["+9611789105",],
    },
    {
      iconSrc: "/Images/Border (2).png",
      title: "Email",
      content: ["support@bbcorp.trade"],
    },
    {
      iconSrc: "/Images/Border (4).png",
      title: "Live Chat",
      content: [
        <Box>
          <Box
            component="a"
            href="https://api.whatsapp.com/send?phone=96171509000"
            target="_blank"
            rel="noopener noreferrer"
            px={4}
            py={1}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              backgroundColor: 'rgba(76, 175, 80, 0.1)',
              borderRadius: '12px',
              textDecoration: 'none', // remove underline
            }}
          >
            <TbBrandWhatsappFilled size={28} color="rgba(76, 175, 80, 1)" />
            <Typography variant="body2" style={{ color: 'rgba(76, 175, 80, 1)' }}>
              Open WhatsApp Portal
            </Typography>
            <FaArrowRightLong color="rgba(76, 175, 80, 1)" />
          </Box>
        </Box>

      ],
    },
  ];

  return (
    <Box sx={{ px: { xs: 2, md: 6 }, py: 4 }}>
      <Grid container spacing={3} justifyContent="center">
        {cards.map((card, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              sx={{
                borderRadius: 3,
                width: 380,
                minHeight: 240,
                height: 240,
                border: "1px solid #ddd",
                display: "flex",
                alignItems: "start",
                justifyContent: "start",
                background: "transparent",
                textAlign: "start",
                boxShadow: "none",
                p: 2,
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    justifyContent: "flex-start",
                    gap: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={card.iconSrc}
                    alt={card.title}
                    sx={{ width: 50, height: 50, mt: 1 }}
                  />

                  <Typography variant="h4" fontWeight="bold" sx={{ mt: 1 }}>
                    {card.title}
                  </Typography>

                  <Box>
                    {card.content.map((line, i) => (
                      <Typography
                        key={i}
                        variant="body2"
                        sx={{
                          color: "#667085",
                          mb: 0.5,
                          px: 0,
                          py: 1,
                          textAlign: "start",
                          fontSize: '20px'
                        }}
                      >
                        {line}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ConatctChat;
